import { __assign, __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import StyledComponent from "./Styled";
import { GuideBox, Typography } from "../..";
/**
 * moaui Styled TextField
 *
 * @param {StyledProps} props - defaultValue, title, titlePosition, error, disabled, placeholder, onChange, value, autoFocus, type, width, height, spacing, textAlign, multiline, rows, maxRows
 * @example
 * <TextField
 * 	id=""
 * 	title="Title"
 * 	titlePosition="left"
 * 	placeholder="Placeholder"
 * 	defaultValue="Default Value"
 * 	error={false}
 * 	disabled={false}
 * 	onChange={() => {}}
 * 	value="Value"
 * 	autoFocus={false}
 * 	type="text"
 * 	width="100px"
 * 	height="30px"
 * 	spacing={1}
 * 	textAlign="left"
 * 	multiline={false}
 * 	rows={1}
 * 	maxRows={1}
 * />
 * @returns {React.ReactElement} moaTextField
 */
var TextField = function (props) {
    var title = props.title, titlePosition = props.titlePosition, rest = __rest(props, ["title", "titlePosition"]);
    var WrappedStyles = {
        width: (props === null || props === void 0 ? void 0 : props.wrappedWidth) || 'auto',
        spacing: props === null || props === void 0 ? void 0 : props.spacing,
        verCenter: true,
        horSpaceBetween: true,
    };
    return (_jsxs(React.Fragment, { children: [title !== "" && titlePosition === 'label' &&
                _jsxs(GuideBox, __assign({}, WrappedStyles, { children: [_jsx(GuideBox, { width: 'auto', children: _jsx(Typography, { children: "".concat(title) }) }), _jsx(GuideBox, { width: props === null || props === void 0 ? void 0 : props.width, children: _jsx(StyledComponent, __assign({}, rest)) })] })), title !== "" && titlePosition === 'left' &&
                _jsxs(GuideBox, __assign({}, WrappedStyles, { row: true, children: [_jsx(GuideBox, { width: 'auto', children: _jsx(Typography, { children: "".concat(title) }) }), _jsx(GuideBox, { width: props === null || props === void 0 ? void 0 : props.width, children: _jsx(StyledComponent, __assign({}, rest)) })] })), title !== "" && titlePosition === 'right' &&
                _jsxs(GuideBox, __assign({}, WrappedStyles, { row: true, children: [_jsx(GuideBox, { width: props === null || props === void 0 ? void 0 : props.width, children: _jsx(StyledComponent, __assign({}, rest)) }), _jsx(GuideBox, { width: 'auto', children: _jsx(Typography, { children: "".concat(title) }) })] })), title === '' &&
                _jsx(StyledComponent, __assign({}, rest))] }));
};
TextField.defaultProps = {
    autoFocus: false,
    type: "text",
    title: "",
    titlePosition: "left",
    error: false,
    disabled: false,
    spacing: 1,
    textAlign: "left",
};
var SampleProps = {
    id: "",
    autoFocus: false,
    type: "text",
    placeholder: "Placeholder",
    title: "Title",
    titlePosition: "left",
    error: false,
    disabled: false,
    onChange: function () { },
    wrappedWidth: '150px',
    width: '100px',
    height: '30px',
    spacing: 1,
    textAlign: "left",
    multiline: false,
    rows: 1,
    maxRows: 1,
};
export default TextField;
export { SampleProps as TextFieldSample, };
